import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HealthCheckComponent } from './health-check/health-check.component';
import { PdfPageComponent } from './pages/public/pdf-page/pdf-page.component';
import { AuthGuard } from './shared/guards/auth.guard';
import { PageNotFoundComponent } from './shared/pages/page-not-found/page-not-found.component';

const routes: Routes = [
  { 
    path: 'health-check', 
    component: HealthCheckComponent 
  },
  { 
    path: 'auth',
    loadChildren: () => import('./pages/public/public.module').then(m => m.PublicModule)
  },
  { 
    path: '1ea2aa0f-f6c5-4b8b-b557-91a796994778',
    loadChildren: () => import('./pages/opened/opened.module').then(m => m.OpenedModule)
  },
  { 
    path: '',
    loadChildren: () => import('./pages/private/private.module').then(m => m.PrivateModule)
  },
  {
    path: 'pdf-page/:id',
    component: PdfPageComponent
  },
  {
    path: '404',
    component: PageNotFoundComponent 
  },
  {
    path: '**',
    redirectTo: '404'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
